<template>
	<v-container>
		<v-dialog v-model="showDialog" scrollable max-width="90%" style="z-index: 1017;">
			<!--<v-skeleton-loader v-if="loading" type="article, actions" />-->
			<v-card>
				<v-card-title style="padding: 5px 0 0 5px;">
					<v-col cols="12">
						<span style="font-size: 20px;">
							{{ $t('wkt.admin.calendar.manage-calendar-rules-window.title') + (calendar ? calendar.name : '') }}
						</span>
						<!--<v-btn icon style="top: -20px; left: 10px; float: right;">
							<v-icon @click="showDialog=false">close</v-icon>
						</v-btn>-->
					</v-col>
				</v-card-title>
				<v-card-text>
					<v-container fluid class="mx-0 pa-4 pb-2" @wheel="onWheel">
						<v-form ref="form">
							<v-row>
								<v-col cols="12" class="mb-6 pa-0">
									<v-data-table
										v-model="selected"
										:headers="headers"
										:items="items"
										:loading="loading"
										:loading-text="$t('wkt.admin.common.table.loading')"
										:no-data-text="$t('wkt.admin.common.table.no_data')"
										:no-results-text="$t('wkt.admin.common.table.no_results')"
										fixed-header
										disable-pagination
										hide-default-footer
										show-select
										checkbox-color="#185EA9"
										calculate-widths
										height="300px"
										class="elevation-0"
									>
										<template v-slot:top>
											<v-toolbar flat color="white">
												<v-row cols="12" v-if="!loading && !errorMessage" class="d-flex justify-space-between">
													<v-col cols="8" class="pa-0">
														<h3 class="d-block">{{ $t('wkt.admin.calendar.wizard-window.calendar_description') }}</h3>
													</v-col>
													<v-col cols="3" class="pa-0 d-flex justify-end align-end">
														<v-btn 
															text
															color="primary"
															@click="addRule()">
															<v-icon class="mr-1">add_circle_outline</v-icon>
															{{ $t('wkt.admin.calendar.manage-calendar-rules-window.add_rule') }}
														</v-btn>
													</v-col>
												</v-row>
											</v-toolbar>
										</template>
										<!--<template v-slot:[`item.order`]="{ item }">
											{{ item.order + 1 }}
										</template>-->
										<template v-slot:[`item.title`]="{ item }">
											{{ item.title }}
										</template>
										<template v-slot:[`item.dayType`]="{ item }">																					
											<span v-if="item.dayType === constants.REGULAR_DAY">
												{{ $t('wkt.admin.calendar.wizard-window.workable') }}
											</span>
											<span v-else-if="item.dayType === constants.REST_DAY">
												{{ $t('wkt.admin.calendar.wizard-window.rest') }}
											</span>
											<span v-else-if="item.dayType === constants.NATIONAL_HOLIDAY">
												{{ $t('wkt.admin.calendar.wizard-window.holiday') }}
											</span>
											<span v-else-if="item.dayType === constants.LOCAL_HOLIDAY">
												{{ '???' }}
											</span>
											<span v-else-if="item.dayType === constants.COMPANY_HOLIDAY">
												{{ $t('wkt.admin.calendar.wizard-window.free') }}
											</span>
											<span v-else>
												{{ $t('wkt.admin.calendar.manage-calendar-rules-window.table.not_modify') }}
											</span>
										</template>
										<template v-slot:[`item.weekdays`]="{ item }">
											<span class="text-capitalize">
												{{ getWeekdayAbbrFormString(item.weekdays).toString().replaceAll(',', ', ') }}
											</span>
										</template>
										<template v-slot:[`item.allowCheckin`]="{ item }">
											<span v-if="item.allowCheckin === -1">
												{{ $t('wkt.admin.calendar.manage-calendar-rules-window.table.not_modify') }}
											</span>
											<span v-if="item.allowCheckin === 0">
												{{ $t('wkt.admin.calendar.manage-calendar-rules-window.table.disallow') }}
											</span>
											<span v-if="item.allowCheckin === 1">
												{{ $t('wkt.admin.calendar.manage-calendar-rules-window.table.allow') }}
											</span>
										</template>
										<template v-slot:[`item.workHours`]="{ item }">
											<span style="display: block; max-width: 200px;">
												<span style="display: block;">
													{{ item.workHours ? convertDoubleToHHMM(item.workHours) : '--' }}
												</span>
												<span v-if="item.modifyWorkHours === true" style="font-size: .8rem; color: #9e9e9e;">
													{{ $t('wkt.admin.calendar.manage-calendar-rules-window.table.set_up') }}
												</span>
												<span v-if="item.modifyWorkHours === false" style="font-size: .8rem; color: #9e9e9e;">
													{{ $t('wkt.admin.calendar.manage-calendar-rules-window.table.not_modify') }}
												</span>
											</span>
										</template>
										<template v-slot:[`item.startTime1`]="{ item }">
											<span>
												{{ `${item.startTime1 && item.finishTime1 ? convertSimpleTimeToHHMM(item.startTime1) + '-' + convertSimpleTimeToHHMM(item.finishTime1) : '' }
													${item.startTime2 && item.finishTime2 ? ',' + convertSimpleTimeToHHMM(item.startTime2) + '-' + convertSimpleTimeToHHMM(item.finishTime2) : '' }
													${item.startTime3 && item.finishTime3 ? ',' + convertSimpleTimeToHHMM(item.startTime3) + '-' + convertSimpleTimeToHHMM(item.finishTime3) : '' }`
													.replaceAll(' ,', ', ')
												}}
											</span>
										</template>
										<template v-slot:[`item.limitCheckin`]="{ item }">										
											<span v-if="item.notBefore && item.notAfter" style="display: block; max-width: 200px;">
												{{ `${convertSimpleTimeToHHMM(item.notBefore)}-${convertSimpleTimeToHHMM(item.notAfter)}` }}
											</span>
											<span v-else style="display: block; max-width: 200px;">
												{{ '--' }}
											</span>
											<span v-if="item.limitCheckin === -1" style="font-size: .8rem; color: #9e9e9e;">
												{{ $t('wkt.admin.calendar.manage-calendar-rules-window.table.not_modify') }}
											</span>
											<span v-if="item.limitCheckin === 0" style="font-size: .8rem; color: #9e9e9e;">
												{{ $t('wkt.admin.calendar.manage-calendar-rules-window.table.not_limit') }}
											</span>
											<span v-if="item.limitCheckin === 1" style="font-size: .8rem; color: #9e9e9e;">
												{{ $t('wkt.admin.calendar.manage-calendar-rules-window.table.limit') }}
											</span>
										</template>
										<template v-slot:[`item.actions`]="{ item }">
											<v-btn 
												text 
												color="#185EA9" 
												:disabled="loading || item.order === 0" 
												style="min-width: 36px; padding: 0;"
												@click="swapRules(items[item.order-1], item)">
												<v-icon color="#185EA9">arrow_upward</v-icon>
											</v-btn>
											<v-btn 
												text 
												color="#185EA9" 
												:disabled="loading || item.order === items.length - 1" 
												style="min-width: 36px; padding: 0;"
												@click="swapRules(item, items[item.order+1])">
												<v-icon color="#185EA9">arrow_downward</v-icon>
											</v-btn>
											<v-btn 
												text
												color="#185EA9" 
												:disabled="loading" 
												class="ml-2"
												@click="editRule(item)">
												{{ $t('wkt.admin.calendar.edit') }}
											</v-btn>
										</template>
										<template v-slot:no-data>
											<EmptyState 
											class="pt-10"
											:title="$t('wkt.admin.common.empty-state.title')" />
										</template>
									</v-data-table> 
								</v-col>
							</v-row>
							<v-row>
								<v-col cols="12">
									<v-row cols="12" v-if="!loading && !errorMessage" class="mb-4 d-flex justify-space-between">
										<v-col cols="8">
											<h3 class="d-block">{{ $t('wkt.admin.calendar.wizard-window.calendar.copy_rule_description') }}</h3>
										</v-col>
									</v-row>
									<v-row>
										<v-col cols="3">
										<v-menu
										:close-on-content-click="true"
										transition="scale-transition"
										offset-y
										min-width="290px">
											<template v-slot:activator="{ on }">
													<v-text-field
													v-model="fromDateFormatted"
													:label="$t('wkt.admin.calendar.manage-calendar-rules-window.start_date')"
													readonly
													v-on="on"
													dense />
											</template>
											<v-date-picker
												v-model="fromDateIso"
												no-title
												scrollable
												:locale="$i18n.locale"
												:min="calendar ? `${calendar.exerciseMin}-01-01` : null"
												:max="calendar ? `${calendar.exerciseMax}-12-31` : null"
											></v-date-picker>
										</v-menu>
									</v-col>
									<v-col cols="3">
										<v-menu
										:close-on-content-click="true"
										transition="scale-transition"
										offset-y
										min-width="290px">
											<template v-slot:activator="{ on }">
													<v-text-field
													v-model="toDateFormatted"
													:label="$t('wkt.admin.calendar.manage-calendar-rules-window.end_date')"
													readonly
													v-on="on"
													dense
													:error-messages="errorDatesMessage" />
											</template>
											<v-date-picker
												v-model="toDateIso"
												no-title
												scrollable
												:locale="$i18n.locale"
												:min="calendar ? `${calendar.exerciseMin}-01-01` : null"
												:max="calendar ? `${calendar.exerciseMax}-12-31` : null"
											></v-date-picker>
										</v-menu>
									</v-col>
									<v-col cols="3">
										<v-btn 
											color="primary"
											class="text--white"
											:disabled="!fromDateFormatted || !toDateFormatted || selected.length === 0"
											@click="executeRules()">
											{{ $t('wkt.admin.calendar.manage-calendar-rules-window.execute_rules') }}
										</v-btn>
									</v-col>
									</v-row>
								</v-col>
							</v-row>
						</v-form>
					</v-container>
				</v-card-text>
				<v-divider></v-divider>
				<v-card-actions>
					<v-spacer></v-spacer>
					<v-btn text @click="close()" style="font-size: 0.9em; font-weight: 400;">{{ $t('wkt.admin.common.dialog-buttons.close').toUpperCase() }}</v-btn>
				</v-card-actions>
			</v-card>
		</v-dialog>

		<CalendarRuleDialog ref="dlgCalendarRule" @show-alert="showAlert($event)" @refresh="getCalendarRules()" />
        <LoadingDialog :loading="showLoadingDialog" />

		<v-snackbar
			v-model="showAlert"
			:timeout="alertTimeout"
			:color="alertColor"
			style="z-index: 1021">
				<span style="color: #ffffff;">{{alertText}}</span>
				<v-btn text @click="showAlert=false">
				<span style="color: #ffffff;">{{$t('wkt.admin.common.dialog-buttons.close')}}</span>
				</v-btn>
		</v-snackbar>
	</v-container>
</template>

<script>
import BaseModule from '../../common/BaseModule.js';
import EmptyState from '../../common/EmptyState.vue';
import LoadingDialog from '../../common/LoadingDialog.vue';
import CalendarRuleDialog from './CalendarRuleDialog.vue';
import api from '../../../api/worktime.js';
import gwt from '../../../api/gwt.js';

  export default {
    name: 'ManageCalendarRulesDialog',
    mixins: [BaseModule],
	components: {
		EmptyState, CalendarRuleDialog, LoadingDialog
	},
    data () {
		return {
			loading: false,	
			calendar: null,
			fromDateFormatted: null,
			fromDateIso: null,
			toDateFormatted: null,
			toDateIso: null,
			items: [],
			selected: [],
			headers: [],
			showAlert: false,
			alertColor: 'error',
			alertText: '',
			alertTimeout: 3000,
			showDialog: false,
			errorMessage: '',
			errorDatesMessage: '',
			showLoadingDialog: false,
			executeCount: 0,
		}
    },
    methods: {
		onWheel(event) {
			event.stopPropagation();
		},
		onReveal(calendar) {			
			this.calendar = calendar;
			this.errorDatesMessage = '';

			if (this.calendar.calendarMode === 0) {
				this.headers = [
					//{ text: this.$t('wkt.admin.calendar.manage-calendar-rules-window.table.headers.order'), value: 'order', sortable: false },
					{ text: this.$t('wkt.admin.calendar.manage-calendar-rules-window.table.headers.title'), value: 'title', sortable: false },
					{ text: this.$t('wkt.admin.calendar.manage-calendar-rules-window.table.headers.day_type'), value: 'dayType', sortable: false },
					{ text: this.$t('wkt.admin.calendar.manage-calendar-rules-window.table.headers.weekdays'), value: 'weekdays', sortable: false },
					{ text: this.$t('wkt.admin.calendar.manage-calendar-rules-window.table.headers.allow_checkin'), value: 'allowCheckin', sortable: false },
					{ text: this.$t('wkt.admin.calendar.manage-calendar-rules-window.table.headers.work_hours'), value: 'workHours', sortable: false },
					{ text: this.$t('wkt.admin.calendar.manage-calendar-rules-window.table.headers.limit_checkin_hours'), value: 'limitCheckin', sortable: false },
					{ text: '', value: 'actions', sortable: false, width: '200px' }
				];
			} else {
				this.headers = [
					//{ text: this.$t('wkt.admin.calendar.manage-calendar-rules-window.table.headers.order'), value: 'order', sortable: false },
					{ text: this.$t('wkt.admin.calendar.manage-calendar-rules-window.table.headers.title'), value: 'title', sortable: false },
					{ text: this.$t('wkt.admin.calendar.manage-calendar-rules-window.table.headers.day_type'), value: 'dayType', sortable: false },
					{ text: this.$t('wkt.admin.calendar.manage-calendar-rules-window.table.headers.weekdays'), value: 'weekdays', sortable: false },
					{ text: this.$t('wkt.admin.calendar.manage-calendar-rules-window.table.headers.allow_checkin'), value: 'allowCheckin', sortable: false },
					{ text: this.$t('wkt.admin.calendar.manage-calendar-rules-window.table.headers.activity_segments'), value: 'startTime1', sortable: false },
					{ text: this.$t('wkt.admin.calendar.manage-calendar-rules-window.table.headers.limit_checkin_hours'), value: 'limitCheckin', sortable: false },
					{ text: '', value: 'actions', sortable: false, width: '200px' }
				];
			}

			this.open();
		},
		open() {
			if (this.$refs.form) {
				this.$refs.form.resetValidation();
			}
				
			this.items = [];
			this.selected = [];
			
			this.showLoadingDialog = false;
			this.executeCount = 0;

			this.fromDateIso = `${this.calendar.exerciseMax}-01-01`;
			this.toDateIso = `${this.calendar.exerciseMax}-12-31`;
				
			this.fromDateFormatted = this.formatOnlyDate(this.fromDateIso);
			this.toDateFormatted = this.formatOnlyDate(this.toDateIso);
				
			this.showDialog = true;

			this.getCalendarRules();
		},
		getCalendarRules() {
			this.selected = [];

			this.loading = true;

			api.getCalendarRulesByCalendarId(this.calendar.id,
				(res) => {
					this.loading = false;
					this.items = res;
				},
				(error) => {
					this.loading = false;
					this.$log.error(error);
					this.doShowAlert({ text: error, color: 'error', timeout: 3000 });
				}
			);
		},
		addRule() {
			this.$refs.dlgCalendarRule.open(this.calendar, null);
		},
		editRule(item) {
			this.$refs.dlgCalendarRule.open(this.calendar, item);
		},
		swapRules(item1, item2) {
			this.loading = true;

			api.swapCalendarRules(this.calendar.id, item1.id, item2.id,
				(res) => {
					this.loading = false;
					if (res) {
						this.getCalendarRules();
					}
				},
				(error) => {
					this.loading = false;
					this.$log.error(error);
					this.doShowAlert({ text: error, color: "error", timeout: 3000 });
				}
			);
		},
		executeRules() {
			if (this.fromDateIso && this.toDateIso) {
				const dtStart = new Date(`${this.fromDateIso}`).getTime();
				const dtEnd = new Date(`${this.toDateIso}`).getTime();
						
				if (dtStart > dtEnd) {
					this.errorDatesMessage = this.$t('wkt.admin.holidays.calendar.edit-holiday-window.new-record-window.errors.end_date_smaller');
					return;
				}
			}
			
			this.errorDatesMessage = '';

			const data = {
				fromDate: this.convertDateToSimpleDate(new Date(this.fromDateIso)),
				toDate: this.convertDateToSimpleDate(new Date(this.toDateIso)),					
				rules: this.buildOperations()
			};

			this.showLoadingDialog = true;		

			api.executeCalendarRulesByCalendarId(this.calendar.id, data,
				() => {
					this.showLoadingDialog = false;
					let message = this.$t('wkt.admin.calendar.manage-calendar-rules-window.rules_executed');
					message = message.replace('%d', this.selected.length);
					this.doShowAlert({ text: message, color: "success", timeout: 6000 });
					this.executeCount++;
				},
				(error) => {
					this.showLoadingDialog = false;
					this.$log.error(error);
					this.doShowAlert({ text: error.message, color: "error", timeout: 3000 });
				}
			);
		},
		buildOperations() {
			let operations = [];

			this.selected.forEach(r => {
				const operation = {
					calendarId: this.calendar.id,
					fromDay: r.fromDay,
					fromMonth: r.fromMonth,
					toDay: r.toDay,
					toMonth: r.toMonth,
					dayType: r.dayType,					
					monday: r.weekdays.split(',').includes('L'),
					tuesday: r.weekdays.split(',').includes('M'),
					wednesday: r.weekdays.split(',').includes('X'),
					thursday: r.weekdays.split(',').includes('J'),
					friday: r.weekdays.split(',').includes('V'),
					saturday: r.weekdays.split(',').includes('S'),
					sunday: r.weekdays.split(',').includes('D'),
					description: r.modifyNotes ? r.notes : null,
					checkinAllowed: r.allowCheckin !== -1 ? !!r.allowCheckin : null,
					//workHours: !r.modifyWorkHours ? null : (!r.workHours ? null : r.workHours),
					workHours: r.modifyWorkHours ? r.workHours : null,
					applyTimeConstraint: r.limitCheckin !== -1 ? !!r.limitCheckin : null,
					notBefore: r.notBefore,
					notAfter: r.notAfter
				};

				if (this.calendar.calendarMode === this.constants.CALENDAR_ASSISTED_CHECKING) {
					let workHours = 0;
					let diff = 0;

					diff = this.getAbsoluteHoursDifference(r.startTime1, r.finishTime1);

					if (diff !== null) {
						operation.startTime1 = r.allowCheckin === 1 ? r.startTime1 : null;
						operation.finishTime1 = r.allowCheckin === 1 ? r.finishTime1 : null;
						workHours += diff;
					}

					diff = this.getAbsoluteHoursDifference(r.startTime2, r.finishTime2);

					if (diff !== null) {
						operation.startTime2 = r.allowCheckin === 1 ? r.startTime2 : null;
						operation.finishTime2 = r.allowCheckin === 1 ? r.finishTime2 : null;
						workHours += diff;
					}					

					diff = this.getAbsoluteHoursDifference(r.startTime3, r.finishTime3);

					if (diff !== null) {
						operation.startTime3 = r.allowCheckin === 1 ? r.startTime3 : null;
						operation.finishTime3 = r.allowCheckin === 1 ? r.finishTime3 : null;
						workHours += diff;
					}

					operation.workHours = workHours;
				}

				operations.push(operation);
			});

			return operations;
		},
		doShowAlert (payload) {
			this.alertText = payload.text;
			this.alertColor = payload.color;
			this.alertTimeout = payload.timeout;
			this.showAlert = true;
		},
		close() {
			this.showDialog = false;

			if (this.executeCount === 0) {
				return;
			}

			const payload = {
				calendarId: this.calendar.id, 
				openRules: false
			};

			gwt.fireEvent('OpenCalendarEvent', JSON.stringify(payload));
		}
    },
	watch: {
		fromDateIso (val) {
			this.fromDateFormatted = this.formatOnlyDate(val);
		},
		toDateIso (val) {
			this.toDateFormatted = this.formatOnlyDate(val);				
		}
	}
  }
</script>